import React from "react";
import { Fade } from "react-awesome-reveal";
import Whats from "./Whats";
import "../styles/Services.scss";
import img1 from "../images/services/1.png";
import img2 from "../images/services/2.png";
import img3 from "../images/services/3.png";
import img4 from "../images/services/4.png";
import img5 from "../images/services/5.png";
import img6 from "../images/services/6.png";

const Services = () => {
  const servicios = [
    {
      id: 1,
      imagen: img1,
      titulo: "Formación y Capacitación en Seguros",
      texto:
        "Brindamos programas completos de formación diseñados para quienes desean construir una carrera sólida en el sector asegurador. Aprenderás desde los fundamentos básicos hasta técnicas avanzadas de ventas y asesoría financiera, con sesiones prácticas, materiales digitales, talleres interactivos y simulaciones reales. Nuestro objetivo es que adquieras confianza, habilidades y herramientas para brindar un servicio profesional, ético y con propósito.",
    },
    {
      id: 2,
      imagen: img2,
      titulo: "Mentorías y Acompañamiento Personalizado",
      texto:
        "No caminarás solo. En Asesorarte en Seguros te guiamos con mentorías individuales y grupales impartidas por líderes con amplia trayectoria. Te ayudamos a trazar metas claras, implementar estrategias efectivas y superar desafíos comunes al iniciar en esta industria. Nuestro acompañamiento es continuo, con retroalimentación personalizada, apoyo emocional y motivacional, y seguimiento de tus avances para que logres resultados reales en menos tiempo.",
    },
    {
      id: 3,
      imagen: img3,
      titulo: "Desarrollo Profesional y Crecimiento Personal",
      texto:
        "Creemos que un gran asesor no solo domina las finanzas, sino también el autoconocimiento y la inteligencia emocional. Por eso, impulsamos tu desarrollo integral con capacitaciones enfocadas en liderazgo, comunicación efectiva, manejo del tiempo y mentalidad de éxito. Nuestro objetivo es ayudarte a crecer como profesional y como persona, para que construyas una carrera con propósito, equilibrio y estabilidad emocional.",
    },
    {
      id: 4,
      imagen: img4,
      titulo: "Comunidad y Networking",
      texto:
        "Formar parte de Asesorarte en Seguros es integrarte a una comunidad activa de agentes con visión, empatía y pasión por ayudar a las familias mexicanas. Aquí podrás conectar con otros emprendedores, compartir experiencias, participar en talleres, masterclass y eventos exclusivos. Nuestro entorno colaborativo impulsa el aprendizaje constante y te permite expandir tu red de contactos profesionales para seguir creciendo en el mundo de los seguros.",
    },
    {
      id: 5,
      imagen: img5,
      titulo: "Bonos, Reconocimientos y Convenciones",
      texto:
        "Reconocemos y celebramos tu esfuerzo. Además de las comisiones, podrás acceder a bonos especiales, premios, certificaciones y viajes de reconocimiento por tu desempeño. Participa en nuestras convenciones nacionales e internacionales, donde vivirás experiencias inolvidables junto a otros asesores que, como tú, trabajan con pasión y compromiso por mejorar la vida de las familias que confían en nosotros.",
    },
    {
      id: 6,
      imagen: img6,
      titulo: "Plan de Carrera y Crecimiento Financiero",
      texto:
        "Diseña tu propio camino hacia la independencia económica con un plan de carrera flexible y transparente. Aquí tú decides cuánto crecer y cuánto ganar, con ingresos residuales, comisiones escalonadas y metas de ascenso claras. Además, te brindamos las herramientas financieras, capacitación continua y mentoría necesaria para que logres la abundancia que deseas, generando bienestar para ti, tu familia y tus clientes.",
    },
  ];

  return (
    <div id="allServices">
      <h4 className="fw-bold mt-5 fs-3 title">Nuestros Servicios</h4>
      {servicios.map((servicio) => (
        <section
          className="cursosContainer"
          id={"servicio" + servicio.id}
          key={servicio.id}
        >
          <div className="imgContainer text-center">
            <Fade duration="1000">
              <img src={servicio.imagen} alt={servicio.titulo} />
            </Fade>
          </div>
          <div className="infoCursoContainer">
            <Fade duration="1000">
              <span className="titleService">
                <strong>{servicio.titulo}</strong>
              </span>
            </Fade>
            <span className="textService">{servicio.texto}</span>

            <div className="btnServiceContainer">
              <Whats
                classStyle="btn btnService"
                phoneNumber="5215584514007"
                message={`¡Me gustaría recibir más información sobre ${servicio.titulo}!`}
                text="¡Quiero saber más!"
              />
            </div>
          </div>
        </section>
      ))}
    </div>
  );
};

export default Services;
